/** Digits-only tel: href for customer service (display form lives in AUTH_CONTENT). */
export const CUSTOMER_SERVICE_PHONE_TEL = '8775817368'
